import JsonLd from './JsonLd'

type BreadcrumbItem = {
  name: string
  url: string
}

export default function BreadcrumbListJsonLd({
  items,
  baseUrl,
}: {
  items: BreadcrumbItem[]
  baseUrl: string
}) {
  const siteHandle = process.env.NEXT_PUBLIC_STATAMIC_SITE_HANDLE || 'blink'
  const siteName = siteHandle === 'nohe' ? 'Nohe' : 'BLINK'

  const normalizeUrl = (url: string) => url.replace(/\/$/, '')
  const normalizedBaseUrl = normalizeUrl(baseUrl)

  let filteredItems = items.filter(
    (item) => normalizeUrl(item.url) !== normalizedBaseUrl
  )

  if (filteredItems.length === 0) {
    return null
  }

  const currentPage = filteredItems[0]
  const url = new URL(currentPage.url)
  const path = url.pathname

  let intermediateBreadcrumb: BreadcrumbItem | null = null

  if (path.startsWith('/fahrschule-')) {
    intermediateBreadcrumb = {
      name: 'Fahrschule',
      url: `${baseUrl}/fahrschule/`,
    }
  } else if (path.startsWith('/vku-')) {
    intermediateBreadcrumb = {
      name: 'VKU',
      url: `${baseUrl}/vku/`,
    }
  } else if (path.startsWith('/nothelferkurs-')) {
    intermediateBreadcrumb = {
      name: 'Nothelfer',
      url: `${baseUrl}/nothelferkurs/`,
    }
  } else if (path.startsWith('/wab-kurs-')) {
    intermediateBreadcrumb = {
      name: 'WAB-Kurs',
      url: `${baseUrl}/wab-kurs/`,
    }
  }

  if (intermediateBreadcrumb) {
    filteredItems = [intermediateBreadcrumb, currentPage]
  }

  const breadcrumbItems = [
    {
      '@type': 'ListItem',
      position: 1,
      name: siteName,
      item: baseUrl,
    },
    ...filteredItems.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 2,
      name: item.name,
      item: item.url,
    })),
  ]

  return (
    <JsonLd
      data={{
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbItems,
      }}
    />
  )
}
